// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const SESSION_TIMEOUT_EMPTY_STATUS_PROPS = {
  image: 'illustration_emptystates_on-hold',
  dataTestId: 'session-timeout-component',
  variant: VARIANTS.EmptyStatusVariantType.DEFAULT,
};

const SESSION_TIMEOUT_BUTTON_PROPS = {
  dataTestId: 'session-timeout-component-button',
  type: 'primary',
};

export { SESSION_TIMEOUT_EMPTY_STATUS_PROPS, SESSION_TIMEOUT_BUTTON_PROPS };
